import React, { useState, useEffect } from "react";

import { updateSubscriptionV2 } from "../../persistence/s3";

import browserHistory from '../../history';

import { Panel } from "react-bootstrap";

import state from "../../state/state";

const Return = (props) => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [subscriptionId, setSubscriptionId] = useState('');

  useEffect(() => {
    async function fetchData() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const sessionId = urlParams.get('session_id');
  
      const response = await fetch(`https://6qlld3f4yl.execute-api.us-east-1.amazonaws.com/prod/stripe-session-status?session_id=${sessionId}`, {
        method: "GET"
      });
      const jsonResponse = await response.json();
      //const newJsonResponse = JSON.parse(jsonResponse.body);
  
      // urlParams.delete("session_id");
      // window.history.replaceState({}, document.title, "/");

      setStatus(jsonResponse.status);
      setCustomerEmail(jsonResponse.customer_email);
      setCustomerId(jsonResponse.customer);
      setSubscriptionId(jsonResponse.subscription);
    }
    fetchData();
  }, []);

  if (status === 'open') {
    alert("There was a problem with the purchase. Try again.");
    browserHistory.push("/perfTrialCheckout");
    // return (
    //   <Navigate to="/checkout" />
    // )
  }

  if (status === 'complete') {
    updateSubscriptionV2(customerId, subscriptionId, props.plan ? props.plan : "pro-plan-performance-as-yearly-v2");

    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%" }}>
          <Panel style={{maxWidth: "800px", marginTop: "100px", marginLeft: "10px", marginRight: "10px"}} defaultExpanded bsStyle="primary">
              <Panel.Heading style={{ backgroundColor: "royalblue", color: "white" }}>
                <Panel.Title>
                  {props.title ? props.title : "Pro Performance Plan"}
                </Panel.Title>
              </Panel.Heading>
              <Panel.Collapse>
                <Panel.Body>
                  {props.content ? props.content : "We appreciate your business! You are now subscribed to the Performance Plan. You paid $5 for the first 3 months. After that, your subscription will auto-renew in the $36 yearly plan."}
                  <br /><br/>
                  If you have any questions, please email <a href="mailto:support@aerosys.io">support@aerosys.io</a>.
                </Panel.Body>
              </Panel.Collapse>
            </Panel>
        </div>    
    )
  }

  return null;
}

export default Return;